import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useMailer } from '../hooks/useMailer';
import '../style.css';

function CourseFinderForm() {
  const [formData, setFormData] = useState({
    horario: '', tipoCurso: '', modalidad: 'presencial', nombre: '', telefono: '', email: ''
  });

  const { send, loading, submitted, ErrorBox } = useMailer('contact');

  const handleChange = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    send({
      nombre:   formData.nombre,
      telefono: formData.telefono,
      correo:   formData.email,
      pregunta: `Horario: ${formData.horario} | Tipo: ${formData.tipoCurso} | Modalidad: ${formData.modalidad}`,
    });
  };

  const selectStyle = {
    width: '100%', padding: '12px 16px', border: '1.5px solid #e5e7eb',
    borderRadius: '8px', fontSize: '0.95rem', fontFamily: 'DM Sans, sans-serif',
    color: 'var(--text)', outline: 'none', background: 'white', cursor: 'pointer'
  };

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Encuentra Tu Curso | Culturlingua</title>
        <meta name="description" content="Encuentra el curso de inglés perfecto para ti. Cuéntanos tus necesidades y te recomendamos la mejor opción." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Orientación gratuita</div>
        <h1>Encuentra Tu Curso</h1>
        <p>Déjanos tus datos, te contactamos y encontramos tu mejor opción.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'640px', margin:'0 auto'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'48px', boxShadow:'0 4px 24px rgba(0,0,0,0.07)'}}>
            <div className="section-tag" style={{marginBottom:'24px'}}>📚 En menos de 1 minuto</div>
            <h2 className="section-headline" style={{fontSize:'1.8rem', marginBottom:'8px'}}>Cuéntanos sobre ti</h2>
            <p style={{color:'var(--muted)', marginBottom:'32px'}}>Completar este formulario nos ayuda a recomendarte el curso ideal.</p>

            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <label className="form-label">Horario preferido</label>
                <select
                  style={selectStyle}
                  value={formData.horario}
                  onChange={e => handleChange('horario', e.target.value)}
                  required
                >
                  <option value="">Selecciona un horario</option>
                  <option value="Matutino (8am-1pm)">Matutino (8am–1pm)</option>
                  <option value="Vespertino (1pm-7pm)">Vespertino (1pm–7pm)</option>
                  <option value="Nocturno (7pm-9pm)">Nocturno (7pm–9pm)</option>
                  <option value="Sabatino">Sabatino</option>
                  <option value="Aún no estoy seguro">Aún no estoy seguro</option>
                </select>
              </div>

              <div className="form-field">
                <label className="form-label">Tipo de curso</label>
                <select
                  style={selectStyle}
                  value={formData.tipoCurso}
                  onChange={e => handleChange('tipoCurso', e.target.value)}
                  required
                >
                  <option value="">Selecciona un tipo</option>
                  <option value="Kinder">Kinder (4–6 años)</option>
                  <option value="Niños">Niños (6–10 años)</option>
                  <option value="Jovenes">Jóvenes (11–15 años)</option>
                  <option value="Adultos">Adultos (15+ años)</option>
                  <option value="Intensivo">Intensivo</option>
                  <option value="Privadas">Clases Privadas</option>
                  <option value="Empresas">Empresarial</option>
                </select>
              </div>

              <div className="form-field">
                <label className="form-label">Modalidad</label>
                <div style={{display:'flex', gap:'16px'}}>
                  {['presencial','online'].map(m => (
                    <label key={m} style={{display:'flex', alignItems:'center', gap:'8px', cursor:'pointer', fontSize:'0.95rem', color:'var(--text)'}}>
                      <input
                        type="radio" name="modalidad" value={m}
                        checked={formData.modalidad === m}
                        onChange={e => handleChange('modalidad', e.target.value)}
                        style={{accentColor:'var(--blue)', width:'16px', height:'16px'}}
                      />
                      {m.charAt(0).toUpperCase() + m.slice(1)}
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-row" style={{marginBottom:'16px'}}>
                <div className="form-field" style={{marginBottom:0}}>
                  <label className="form-label">Nombre</label>
                  <input className="form-input" type="text" value={formData.nombre} onChange={e => handleChange('nombre', e.target.value)} placeholder="Tu nombre" required />
                </div>
                <div className="form-field" style={{marginBottom:0}}>
                  <label className="form-label">Teléfono</label>
                  <input className="form-input" type="tel" value={formData.telefono} onChange={e => handleChange('telefono', e.target.value)} placeholder="+52 33..." required />
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">Email</label>
                <input className="form-input" type="email" value={formData.email} onChange={e => handleChange('email', e.target.value)} placeholder="tu@correo.com" required />
              </div>

              {submitted ? (
                <div style={{textAlign:'center', padding:'40px 0'}}>
                  <div style={{fontSize:'3rem', marginBottom:'16px'}}>✅</div>
                  <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.6rem', marginBottom:'10px'}}>¡Listo!</h3>
                  <p style={{color:'var(--muted)'}}>Recibimos tu solicitud. Te contactamos en menos de 1 hora en horario de oficina.</p>
                </div>
              ) : (
                <>
                  {ErrorBox}
                  <button type="submit" className="form-submit" style={{marginTop:'8px'}} disabled={loading}>
                    {loading ? 'Enviando...' : 'Enviar y encontrar mi curso →'}
                  </button>
                </>
              )}
            </form>
          </div>

          <p style={{textAlign:'center', color:'var(--muted)', fontSize:'0.85rem', marginTop:'20px'}}>
            Sin compromisos. Te respondemos en menos de 1 hora en horario de oficina.
          </p>
        </div>
      </section>
    </div>
  );
}

export default CourseFinderForm;
